import type { GridColDef } from '@mui/x-data-grid'
import EccentricitySymbol from '@editor/components/CheckSettingsFormFields/LoadEccentricityFormFields/components/EccentricitySymbol'
import { CheckSettingsRow } from '../MultiEditCheckSettings/types'

export const loadEccentricitySettingsColumns: GridColDef<CheckSettingsRow>[] = [
  {
    field: 'eccentricityY',
    headerName: 'Exzentrizität y',
    renderHeader: () => <EccentricitySymbol axis="y" />,
    flex: 1,
    minWidth: 90,
  },
  {
    field: 'eccentricityZ',
    headerName: 'Exzentrizität z',
    renderHeader: () => <EccentricitySymbol axis="z" />,
    flex: 1,
    minWidth: 90,
  },
]
